class InitiatorChecker {
  constructor () {
    this.props = {
      pro_login_path: '/pages/pro-login',
      subscriptions_path: '/pages/spurit-subscriptions',
      login_path: '/account/login',
      register_path: '/account/register',
      challenge_path: '/challenge',
      storage_key: 'isProLogin',
      subscription_refer: 'subscriptionRefer',
      authed_customer_key: 'authed_customer'
    };
    this.init();

  }

  isProLoginReffer () {
    return document.referrer.indexOf(this.props.pro_login_path) !== -1;
  }

  isProLoginStorage () {
    return sessionStorage.getItem(this.props.storage_key) * 1;
  }
  isSubscriptionStorage () {
    return sessionStorage.getItem(this.props.subscription_refer) * 1;
  }

  isAccountLogin () {
    return window.location.pathname.indexOf(this.props.login_path) !== -1;
  }

  isAccountRegister () {
    return window.location.pathname.indexOf(this.props.register_path) !== -1;
  }

  isChallenge () {
    return window.location.pathname.indexOf(this.props.challenge_path) !== -1;
  }

  init () {
    if(this.isAccountRegister() && !this.isSubscriptionStorage()) {
      const passwordField = document.querySelector('input[name="customer[password]"]');
      if(passwordField) {
        passwordField.type = 'password';
        passwordField.value = '';
        passwordField.closest('div.field')?.classList.remove('hidden');
      }
    }
    if (this.isChallenge()) {
      if (this.isProLoginReffer()) {
        sessionStorage.setItem(this.props.storage_key, '1');
      }
    } else if (this.isAccountLogin() && (this.isProLoginReffer() || this.isProLoginStorage())) {
      sessionStorage.removeItem(this.props.storage_key);
      window.location.replace(this.props.pro_login_path);
    } else {
      if (this.isProLoginStorage()) {
        sessionStorage.removeItem(this.props.storage_key);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new InitiatorChecker();
});
